import React from "react";
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const [innerOpen, setInnerOpen] = React.useState(false);
    const itemArray = row.value.filter((x) => x.curveNumber != '');
    const groupedByItemNumberMap = itemArray != undefined ? Map.groupBy(itemArray, ({ curveNumber }) => curveNumber) : itemArray;
    const groupedByItemNumberArray = groupedByItemNumberMap != undefined ? Array.from(groupedByItemNumberMap, ([name, value]) => ({ name, value })) : [];
 
    const filteredItemArray = row.value.filter((x) => x.orderNmbr_DriveControl != "" || x.orderNmbr_Motor != "" || x.orderNmbr_Pump != ""
        || x.orderNmbr_PumpMotor != "" || x.orderNmbr_addons != "");
    const groupByDriveControlMap = filteredItemArray != undefined ? Map.groupBy(filteredItemArray, ({ orderNmbr_DriveControl }) => orderNmbr_DriveControl) : filteredItemArray;
    const groupByDriveControlArray = groupByDriveControlMap != undefined ? Array.from(groupByDriveControlMap, ([name, value]) => ({ name, value }))
        .filter((x) => x.name != '') : [];

    const groupByPumpMap = filteredItemArray != undefined ? Map.groupBy(filteredItemArray, ({ orderNmbr_Pump }) => orderNmbr_Pump) : filteredItemArray;
    const groupByPumpArray = groupByPumpMap != undefined ? Array.from(groupByPumpMap, ([name, value]) => ({ name, value }))
        .filter((x) => x.name != '') : [];

    const groupByMotorMap = filteredItemArray != undefined ? Map.groupBy(filteredItemArray, ({ orderNmbr_Motor }) => orderNmbr_Motor) : filteredItemArray;
    const groupByMotorArray = groupByMotorMap != undefined ? Array.from(groupByMotorMap, ([name, value]) => ({ name, value }))
        .filter((x) => x.name != '') : [];

    const groupByPumpMotorMap = filteredItemArray != undefined ? Map.groupBy(filteredItemArray, ({ orderNmbr_PumpMotor }) => orderNmbr_PumpMotor) : filteredItemArray;
    const groupByPumpMotorArray = groupByPumpMotorMap != undefined ? Array.from(groupByPumpMotorMap, ([name, value]) => ({ name, value }))
        .filter((x) => x.name != '') : [];

    const groupByAddonMap = filteredItemArray != undefined ? Map.groupBy(filteredItemArray, ({ orderNmbr_addon }) => orderNmbr_addon) : filteredItemArray;
    const groupByAddonArray = groupByAddonMap != undefined ? Array.from(groupByAddonMap, ([name, value]) => ({ name, value }))
        .filter((x) => x.name != '') : [];

    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row" sx={{ fontSize: '12px' }}>
                    {row.name}
                </TableCell>
                <TableCell component="th" scope="row" sx={{ fontSize: '12px' }}>
                    {row.value.length}
                </TableCell>
            </TableRow>
            <TableRow sx={{background: 'white'} }>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Table size="small" aria-label="purchases">
                                <TableBody>
                                    {groupedByItemNumberArray.length > 0 && groupedByItemNumberArray.map((historyRow) => (
                        
                                        <>
                                            <TableRow>
                                                <TableCell sx={{ fontSize: '16px' }}>Curve Number</TableCell>
                                                <TableCell sx={{ fontSize: '16px' }}># of Selections</TableCell>
                                            </TableRow>
                                            <TableRow key={historyRow.curveNumber}>
                                            <TableCell component="th" scope="row" sx={{ fontSize: '16px' }}>
                                                {historyRow.name}
                                            </TableCell>
                                            <TableCell component="th" scope="row" sx={{ fontSize: '16px' }}>
                                                {historyRow.value.length}
                                            </TableCell>
                                            </TableRow>
                                            <TableRow>
                                            <TableCell/>
                                                <TableCell sx={{ fontSize:"12px", fontWeight: "bold" }}>{"Drive Control"}</TableCell>
                                                <TableCell sx={{ fontSize:"12px", fontWeight: "bold" }}>{"Pump"}</TableCell>
                                                <TableCell sx={{ fontSize:"12px", fontWeight: "bold" }}>{"Motor"}</TableCell>
                                                <TableCell sx={{ fontSize:"12px", fontWeight: "bold" } }>{"Pump Motor"}</TableCell>
                                                <TableCell sx={{ fontSize:"12px", fontWeight: "bold" } }>{"Add-On"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                            <TableCell/>
                                                <TableCell sx={{ fontSize:"12px"}}>{console.log(groupByDriveControlArray.filter((x) => x.value.curveNumber == historyRow.value.curveNumber && x.value.productLine_ID == historyRow.value.productLine_ID).length)}</TableCell>
                                                <TableCell sx={{ fontSize: "12px" }}>{groupByPumpArray.filter((x) => x.value.curveNumber == historyRow.value.curveNumber && x.value.productLine_ID == historyRow.value.productLine_ID).length}</TableCell>
                                                <TableCell sx={{ fontSize: "12px" }}>{groupByMotorArray.filter((x) => x.value.curveNumber == historyRow.value.curveNumber && x.value.productLine_ID == historyRow.value.productLine_ID).length}</TableCell>
                                                <TableCell sx={{ fontSize: "12px" }}>{groupByPumpMotorArray.filter((x) => x.value.curveNumber == historyRow.value.curveNumber && x.value.productLine_ID == historyRow.value.productLine_ID).length}</TableCell>
                                                <TableCell sx={{ fontSize: "12px" }} >{groupByAddonArray.filter((x) => x.value.curveNumber == historyRow.value.curveNumber && x.value.productLine_ID == historyRow.value.productLine_ID).length}</TableCell>
                                            </TableRow>
                                          </>
                                    ))}
                                    {groupedByItemNumberArray.length == 0 &&
                                        <TableRow>
                                            <TableCell>
                                                <TableCell sx={{ fontSize: '16px' }}>Quote Not Generated on this Productline</TableCell>
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
          
           
        </React.Fragment>
    );
}

function InnerRow(props) {
    const { row } = props;
   
    const filteredItemArray = row.value.filter((x) => x.orderNmbr_DriveControl != "" || x.orderNmbr_Motor != "" || x.orderNmbr_Pump != ""
        || x.orderNmbr_PumpMotor != "" || x.orderNmbr_addons != "");
    
    return (
        <React.Fragment>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell component="th" scope="row" sx={{ fontSize: '16px' }}>
                    {row.name}
                </TableCell>
                <TableCell component="th" scope="row" sx={{ fontSize: '16px' }}>
                    {row.value.length}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={false} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell />
                                        <TableCell sx={{ fontSize: '16px', fontWeight: "bold" }}>Curve Number</TableCell>
                                        <TableCell sx={{ fontSize: '16px', fontWeight: "bold" }}># of Selections</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredItemArray.length > 0 && filteredItemArray.map((historyRow) => (
                                        <TableRow key={historyRow.curveNumber}>
                                            <TableCell component="th" scope="row" sx={{ fontSize: '16px' }} >
                                                {historyRow.name}
                                            </TableCell>
                                            <TableCell component="th" scope="row" sx={{ fontSize: '16px' }}>
                                                {0}
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                    {filteredItemArray.length == 0 &&
                                        <TableRow>
                                            <TableCell>
                                                <TableCell sx={{ fontSize: '16px' }}>Quote Not Generated on this Productline</TableCell>
                                            </TableCell>
                                        </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export const CollapsedTable = (row) => {
return (
        <TableContainer >
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                    <TableCell sx={{ fontSize: '16px', fontWeight: "bold" }}>Product Lines</TableCell>
                    <TableCell sx={{ fontSize: '16px', fontWeight: "bold" }}>Product Line Selections</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {row.outerArray.map((rows) => (
                        <Row key={rows.name} row={rows} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
);
}
